import { render, staticRenderFns } from "./RecruitmentInfo.vue?vue&type=template&id=08faeb5b&scoped=true&"
import script from "./RecruitmentInfo.vue?vue&type=script&lang=js&"
export * from "./RecruitmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./RecruitmentInfo.vue?vue&type=style&index=0&id=08faeb5b&lang=stylus&scoped=true&"
import style1 from "./RecruitmentInfo.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08faeb5b",
  null
  
)

export default component.exports